
import React, { useEffect, useState } from 'react'
import { Paragraph, SectionInfo } from 'types/Challenge'
import Typography from 'Components/Base/Typography'
import Row from 'Components/Base/Row'
import Column from 'Components/Base/Column'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import ResponsiveContainer from 'Components/Base/ResponsiveContainer'

interface Props {
  step: number
  setInfoPage: (infoPage: boolean) => void
}
export default function BPStep7({ step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()
  const [isMobile, setIsMobile] = useState<boolean>()

  useEffect(() => {

    window.scrollTo(0, 0)
    setInfoPage(true)
    setSectionInfo(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2])))
    setStepParagraphs(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]))?.paragraphs)
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1200) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })

    if (window.innerWidth < 1200) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [step])


  return (
    <ResponsiveContainer>
      <Column styles={{ margin: isMobile ? '20px auto' : 'auto 0px' }}>
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
          <Typography variant='h1'>{sectionInfo?.titles.find((title) => title.titleId === 6)?.titleText ?? ''}</Typography>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '10px 0px' }}>
          <p style={{ fontFamily: 'Raleway', fontSize: 20 }}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 12)?.paragraph ?? ''}</p>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 40px' : '10px 40px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', textDecoration: 'underline', fontSize: 20 }}><a href={stepParagraphs?.find((paragraph) => paragraph.paragraphId === 13)?.paragraph ?? ''} target='_blank' rel='noreferrer'>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 13)?.paragraph ?? ''}</a></li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 40px' : '10px 40px 80px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', textDecoration: 'underline', fontSize: 20 }}><a href={stepParagraphs?.find((paragraph) => paragraph.paragraphId === 14)?.paragraph ?? ''} target='_blank' rel='noreferrer'>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 14)?.paragraph ?? ''}</a></li>
        </Row>

      </Column>
      <Column styles={{ width: '100%' }}>
      </Column>
    </ResponsiveContainer>
  )
}

